<div id="dialogContainer">
  <div id="dialogHeader">
    <strong>{{title}}</strong>
  </div>
  <div id="dialogContent">
    <ng-template #container></ng-template>
  </div>
  <div id="dialogFooter" [class.wba]="environment.type != 'web'">
    <button *ngFor="let button of buttons"
      [mat-dialog-close]="button.key"
      (click)="btnFunktion(button.param)"
      [style.background-color]="button.color"
      [style.width.%]="99 / buttons.length">
      {{ button.label }}
    </button>
  </div>
</div>
